/**
 * @param  {string}     string: Remove non digit characters
 * @return {string}     formatted string with only digits
 */
export const stripNonDigits = (string: string): string =>
    string.replace(/[^0-9]/g, '');

export const inIframe = (): boolean => window.top !== window.self;
